import React from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import posthog from 'posthog-js'
import classNames from 'classnames'

const TrackableNavLink = ({ to, children, title, className, ...props }) => {
  const history = useHistory()

      // Determine the link text for tracking
  const linkText =
    title || (typeof children === 'string' ? children : 'Non-text link')

  const handleClick = event => {
    // Prevent default behavior
    event.preventDefault()

    // Track the click event in PostHog
    posthog.capture('nav_link_clicked', { path: to, linkText })

    // Use history.push to navigate after tracking
    history.push(to)
  }

  return (
    <NavLink to={to} onClick={handleClick} className={classNames('rounded', className)} {...props}>
      {children}
    </NavLink>
  )
}

export default TrackableNavLink
